import {Component, OnInit, input} from '@angular/core';
import {Store} from '@ngrx/store';

import * as fromProfile from './../store/profile.reducers';
import * as fromApp from './../../store/app.reducers';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-progress',
    templateUrl: './progress.component.html',
    styleUrls: ['./progress.component.scss'],
    standalone: false
})
export class ProgressComponent implements OnInit {

  readonly type = input<any>();
  profileState: Observable<fromProfile.State>;

  constructor(
    private store: Store<fromApp.AppState>
  ) { }

  ngOnInit() {
    this.profileState = this.store.select('profile');
  }

}
